export default "__VITE_ASSET__URy$$W00__"